const API_BASE = process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:3005/api';

export default API_BASE;
